import { ref, computed, watch, onMounted, defineEmits } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';
import { useStore } from 'vue2-helpers/vuex';
import { getGraphqlSchema } from '@/graphql/index';

import { EventBus } from '@/mixins';

const { resolveClient } = useApolloClient();

const openSearchLiveContentFilters = () => JSON.parse(JSON.stringify([
  {
    bool: {
      should: [
        { bool: { must_not: [{ exists: { field: 'startPublicationDate' } }] } },
        { bool: { must: [{ range: { startPublicationDate: { lte: 'now' } } }] } }
      ]
    }
  },
  {
    bool: {
      should: [
        { bool: { must_not: [{ exists: { field: 'endPublicationDate' } }] } },
        { bool: { must: [{ range: { endPublicationDate: { gte: 'now' } } }] } }
      ]
    }
  },
  {
    terms: {
      online: [
        true
      ]
    }
  }
]));

function useFacetSettings (newFacet, facets) {
  const facetsList = computed(() => {
    const filteredFacets = facets.filter(value => {
    // When we don't want to show
      if (value.config && value.config.hidden) {
        return;
      }
      return value;
    });

    return filteredFacets;
  });
  const facetSettings = computed(() => facetsList.value.find(f => f.value === newFacet.value.facet));

  const disableCopyPaste = computed(() => {
    const copyPasteConfig = facetSettings.value;
    return copyPasteConfig && copyPasteConfig.config.disableCopyPaste;
  });

  const searchByQuery = computed(() => {
    if (facetSettings.value && facetSettings.value.config && facetSettings.value.config.searchByQuery) {
      return true;
    }

    return false;
  });

  return { disableCopyPaste, searchByQuery, facetsList, facetSettings };
}

export {
  openSearchLiveContentFilters,
  useFacetSettings
};
